
import { getPicUrl } from '@/utils/utils'

export function imgUrlFormat(url) {
	return `${ getPicUrl() }${url}`
}
